var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "menu" }, [
    _c("div", { staticClass: "menu-desktop" }, [
      _c(
        "ul",
        { staticClass: "menulist" },
        [
          _c("li", [_vm._v("\n        Todos\n      ")]),
          _vm._v(" "),
          _vm._l(_vm.categories, function(category, index) {
            return _c(
              "li",
              {
                key: index,
                class: { active: true, $category: true },
                on: {
                  click: function($event) {
                    return _vm.updatePosts(category.id)
                  }
                }
              },
              [_vm._v("\n        " + _vm._s(category.title) + "\n      ")]
            )
          })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "menu-mobile-container" }, [
      !_vm.isHidden
        ? _c(
            "ul",
            {
              attrs: { id: "menu-mobile" },
              on: {
                click: function($event) {
                  _vm.isHidden = !_vm.isHidden
                }
              }
            },
            [_c("span", [_vm._v(" Todos ")])]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isHidden
        ? _c(
            "ul",
            {
              attrs: { id: "menu-mobile" },
              on: {
                click: function($event) {
                  _vm.isHidden = !_vm.isHidden
                }
              }
            },
            [
              _c("span", [_vm._v(" Todos ")]),
              _vm._v(" "),
              _vm.isHidden
                ? _c(
                    "li",
                    {
                      on: {
                        click: function($event) {
                          return _vm.updatePosts(10)
                        }
                      }
                    },
                    [_vm._v("\n        Todos.\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.categories, function(category, index) {
                return _c(
                  "li",
                  {
                    key: index + "mobile",
                    attrs: { value: category.id },
                    on: {
                      click: function($event) {
                        return _vm.updatePosts(category.id)
                      }
                    }
                  },
                  [_vm._v("\n        " + _vm._s(category.name) + "\n      ")]
                )
              })
            ],
            2
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }